import CustomWatermarkPage from "components/Features/SingleFeaturePages/CustomWatermark";

export default CustomWatermarkPage;
